import { Link } from 'react-router-dom';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MANAGEMENT } from '../../../shared/constants/app';
import { useEffect, useState } from 'react';
import { getMAAAA000 } from '../../../services/Api';
import moment from 'moment';
import MAAAA001 from '../MAAAA001';

const MAAAA000 = () => {
    const [data, setData] = useState([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [detailData, setDetailData] = useState({});

    const getListData = () => {
        getMAAAA000()
            .then(({ data }) => {
                setData(data);
            })
            .catch((error) => console.log(error));
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setDetailData({});
        getListData();
    };

    const handleCreate = () => {
        setIsPopupOpen(true);
    };

    const handleEdit = (seq) => {
        setIsPopupOpen(true);
        const selectedData = data.find((item) => item.seq === seq);
        setDetailData(selectedData);
    };

    useEffect(() => {
        getListData();
    }, []);

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MANAGEMENT} />
                <div className="content-right">
                    <h1 className="title">관리자 계정관리</h1>
                    <div className="results gray">
                        <div className="button-item">
                            <Link
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleCreate();
                                }}
                            >
                                관리자 추가
                            </Link>
                        </div>
                        <table className="table-gray">
                            <thead>
                                <tr>
                                    <th>아이디</th>
                                    <th>관리자명</th>
                                    {/* <th>생년월일</th> */}
                                    <th>휴대폰번호</th>
                                    <th>이메일</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data && data?.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <button onClick={() => handleEdit(item.seq)}>{item.memberID}</button>
                                            </td>
                                            <td>{item.nameKor}</td>
                                            {/* <td>{moment(item.residentNo, 'YYMMDD').format('YYYY.MM.DD')}</td> */}
                                            <td>
                                                {item.mobileNo}
                                            </td>
                                            <td>{item.email}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5}>데이타가 없습니다.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isPopupOpen && <MAAAA001 closePopup={closePopup} data={detailData} />}
        </div>
    );
};

export default MAAAA000;
